import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useCallback, useEffect, useState } from 'react';
import { useCourses } from '../courses/Courses';
import { useGrades } from '../grades/Grades';
import { useInstitutions } from '../institutions/Institutions';
import { useActivity } from './WorkShopsPreview';

export function ReviewWorkShop(props) {
  const { activity } = useActivity();
  const [filter, setFilter] = useState(null);
  const { institutions } = useInstitutions();
  const { grades } = useGrades();
  const { courses, setCourses } = useCourses();
  const [califications, setCalifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (courses && filter?.grade) {
      let coursesByGrade = courses?.filter(
        (course) => course?.grade?._id === filter?.grade
      );
      setCourses(coursesByGrade);
    }
  }, [filter?.grade]);

  const getCalificationsOfActivity = useCallback(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/califications/filter', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ evaluation: activity?._id, ...filter }),
    })
      .then((res) => res.json())
      .then((data) => {
        setIsLoading(false);
        const cals = data?.data?.map((calification) => {
          return {
            _id: calification?._id,
            student: calification?.student?._id,
            evaluation: calification?.evaluation?._id,
            institution: calification?.institution?._id,
            studentName: calification?.student?.name,
            studentLastName: calification?.student?.lastName,
            studentCalification: calification?.calification,
          };
        });
        console.log(cals);
        setCalifications(cals);
      });
  }, [filter]);

  const handleDelete = useCallback(
    ({ data }) => {
      const confirm = window.confirm(
        '¿Está seguro que desea eliminar las calificaciones seleccionadas?'
      );

      if (!confirm) {
        return false;
      }
      console.log(data);
      console.log(califications);
      data.forEach(({ dataIndex }) => {
        const calification = califications[dataIndex];
        console.log(calification?._id);
        fetch(
          `https://api.edicionesmilenio.com/api/califications/${calification?._id}`,
          {
            method: 'DELETE',
          }
        )
          .then((res) => res.json())
          .then((data) => {
            getCalificationsOfActivity();
          });
      });
    },
    [califications]
  );

  const columns = [
    {
      name: 'studentName',
      label: 'Nombre',
    },
    {
      name: 'studentLastName',
      label: 'Apellido',
    },
    {
      name: 'studentCalification',
      label: 'Calificación',
    },
  ];

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h1 className={classes.activityTitle}>{activity?.title}</h1>

      <div className={classes.filterRoot}>
        <FormControl className={classes.input}>
          <InputLabel id="label-institution">Institución</InputLabel>
          <Select
            labelId="label-institution"
            id="select-institution"
            value={filter?.institution || ''}
            onChange={(e) =>
              setFilter({ ...filter, institution: e.target.value })
            }
            variant="outlined"
            label="Institución"
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {institutions?.map((institution) => (
              <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="grade-label">Grado</InputLabel>
          <Select
            labelId="grade-label"
            id="grade"
            name="grade"
            value={filter?.grade || ''}
            onChange={(e) => setFilter({ ...filter, grade: e.target.value })}
            label="Grado"
          >
            {grades?.map((grade) => (
              <MenuItem value={grade?._id}>{grade?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="course-label">Curso</InputLabel>
          <Select
            labelId="course-label"
            id="course"
            name="course"
            value={filter?.course || ''}
            onChange={(e) => setFilter({ ...filter, course: e.target.value })}
            label="Curso"
          >
            {courses?.map((course) => (
              <MenuItem value={course?._id}>
                {course?.numericName} ({course?.alphaName})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          style={{ height: '30px' }}
          disabled={!filter?.institution || !filter?.grade || !filter?.course}
          onClick={getCalificationsOfActivity}
        >
          Filtrar
        </Button>
      </div>
      <br></br>
      {!isLoading ? (
        <MUIDataTable
          title={'Calificaciones'}
          data={califications}
          columns={columns}
          options={{
            filterType: 'checkbox',
            onRowsDelete: handleDelete,
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    paddingLeft: '40px',
    paddingRight: '40px',
    width: '100%',
  },
  activityTitle: {
    fontFamily: 'Roboto',
    fontSize: '30px',
    color: '#888',
    textAlign: 'center',
    alignSelf: 'center',
  },
  filterRoot: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    width: '30%',
  },
}));
